module.exports = __webpack_public_path__ + "static/media/severity0.beebe542.png";